export default __webpack_public_path__ + "static/media/Documentos-afiliacion-banco-solidario-natural.cf73c07b.pdf";